import React from 'react';
import * as S from './style';

export default function CardGerericoResumo({ titulo, descricao, icon, style }) {
  return (
    <S.CardServico style={style} className="boxShadow">
      <S.CardServicoIcone>{icon}</S.CardServicoIcone>
      <S.CardServicoLabel>{titulo}</S.CardServicoLabel>
      <S.CardServicoDescricao>{descricao}</S.CardServicoDescricao>
    </S.CardServico>
  );
}
